import { render, staticRenderFns } from "./modifyFolderNotesComponent.vue?vue&type=template&id=c0eb09cc&"
import script from "./modifyFolderNotesComponent.vue?vue&type=script&lang=js&"
export * from "./modifyFolderNotesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports